export default __webpack_public_path__ + "static/media/ic_rotate_left.ed686675.svg";